import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext, StateToken } from '@ngxs/store';
import { BookingModel } from '@shared/booking-feature';
import { BookingStateModel } from './booking-state.model';
import { BookingActions } from './booking.actions';

const BOOKING_STATE_TOKEN: StateToken<BookingStateModel> = new StateToken('BookingState');

const DEFAULT_STATE: BookingStateModel = {
    booking: null,
};

@State<BookingStateModel>({
    name: BOOKING_STATE_TOKEN,
    defaults: DEFAULT_STATE,
    children: [],
})
@Injectable()
export class BookingState {
    @Selector()
    static booking(state: BookingStateModel): BookingModel | null {
        return state.booking;
    }

    @Action(BookingActions.SetSelectedBooking)
    setSelectedBooking(ctx: StateContext<BookingStateModel>, action: BookingActions.SetSelectedBooking) {
        ctx.patchState({ booking: action.booking });
    }

    @Action(BookingActions.ClearSelectedBooking)
    clearSelectedBooking(ctx: StateContext<BookingStateModel>) {
        ctx.patchState({ booking: null });
    }
}
